import { Dispatch, SetStateAction } from 'react';
import { useQuery, useQueryClient } from 'react-query';

import {
  compnayListKey,
  employerApplicationsKey,
  enterpriseList,
  errorMessage,
} from '@features/applications';
import axiosInstance from '@server/axiosInstance';

type useGetCompaniesListProps = {
  searchValue: string;
  page: number;
  page_length: number;
  columnNo: number;
  sortedDirection: string;
  setAlertText?: Dispatch<SetStateAction<string>>;
};

export const useGetCompaniesList = ({
  page,
  page_length,
  searchValue,
  columnNo,
  sortedDirection,
  setAlertText = () => { },
}: useGetCompaniesListProps) => {
  const client = useQueryClient();
  const encodedSearchValue = encodeURIComponent(searchValue);
  const queryString = `?page=${page}&page_length=${page_length}&query=${encodedSearchValue}&sort_columns=${columnNo}&sort_direction=${sortedDirection}`;
  const { data: searchCompaniesData, isFetching: isSearchingCompaniesData } =

    useQuery({
      queryKey: [compnayListKey, employerApplicationsKey, page, sortedDirection, columnNo, searchValue, page_length],
      queryFn: () =>

        axiosInstance
          .get(enterpriseList + queryString)
          .then((res) => res.data),
      onSuccess: (data) => {
        if (data.status !== 200) {
          setAlertText(data.message);
        } else {
          setAlertText('');
        }
      },
      onError: () => {
        setAlertText(errorMessage);
        client.invalidateQueries([compnayListKey]);
      },
      refetchOnWindowFocus: false,
    });

  return {
    searchCompaniesData,
    isSearchingCompaniesData,
  };
};
